import { useIntl } from "react-intl";

import UFOSegment from "@atlaskit/react-ufo/segment";

import { EnhancedBanner } from "@/libraries/design/components/enhanced-banner/src/enhanced-banner";
import { checkFeatureFlagGate } from "@/utils/feature-flags/check-feature-flag";
import { featureFlags } from "@/utils/feature-flags/feature-flag-manifest";

export const HomePageBannerAlert = () => {
    const intl = useIntl();

    if (checkFeatureFlagGate(featureFlags.team26EuAnnouncementBanner)) {
        return (
            <UFOSegment name="team26-eu-announcement-banner">
                <EnhancedBanner
                    uniqueIdentifier="team26-eu-announcement-banner"
                    heading={intl.formatMessage({
                        id: "HomePage.banner-alert.team26-eu-announcement.heading",
                        defaultMessage: "6 - 8 October  •  Amsterdam"
                    })}
                    subheading={intl.formatMessage({
                        id: "HomePage.banner-alert.team26-eu-announcement.subheading",
                        defaultMessage:
                            "Maximize savings on your in-person pass & build the future of human + AI collaboration."
                    })}
                    ctaLinkHref={
                        "https://events.atlassian.com/teameurope?utm_medium=event-web-referral&utm_source=cross-[…]me&utm_content=wac_enhancedbanner_homepage&event_id=345414"
                    }
                    ctaLinkText="Register now"
                    productKey="home"
                    logoSrc="https://dam-cdn.atl.orangelogic.com/CDNLink/AT12NFYT.svg"
                    logoAlt="Team26 Europe logo"
                    backgroundImageDesktop="https://dam-cdn.atl.orangelogic.com/CDNLink/AT12NFYP.png"
                    backgroundImageTablet="https://dam-cdn.atl.orangelogic.com/CDNLink/AT12NFYS.png"
                    backgroundImageMobile="https://dam-cdn.atl.orangelogic.com/CDNLink/AT12NFYQ.png"
                    backgroundColor="black"
                />
            </UFOSegment>
        );
    }
};
